'use client';
import { Col, Row, Tooltip } from "antd";
import React, { useEffect } from "react";
import "./style.css";
import { useDispatch } from 'react-redux';
import { accountPackageActions, colors, formatMsg, Helper, LinkWrapper, timeutil, PrefixIconButton, wrapperComponents, getItem } from "sharedresources";
const { sliceOperation, updateWishlist } = accountPackageActions;
const { CardWrapper } = wrapperComponents;

const PackageView: React.FC<any> = (props) => {
	const dispatch = useDispatch();
	const { loggedInData, accountPackageReducer } = Helper.getSelectorState(["accountPackageReducer"]);
	const { packageObj, redirectTo } = props;
	const {
		name,
		startDate,
		endDate,
		type,
		ageRange,
		activities,
		coverPhoto, startTime,
		endTime,
		description,
		classPacks,
		staffIds,
		maxCapacity,
		mode,
		id,
		wishListed,
		bookingStatus,
	} = packageObj;

	function callUpdateWishlist(addOrRemove) {
		dispatch(updateWishlist({ loggedInData, addOrRemove, packageId: id }))
	}

	useEffect(() => {
		if (accountPackageReducer.operationType === "UPDATE_WISHLIST") {
			dispatch(sliceOperation({ operationType: undefined }))
		}
	}, [accountPackageReducer.operationType])


	function getBookingStatus() {
		let bookingStatusArray = accountPackageReducer?.sellingFast || [];
		if (bookingStatusArray && bookingStatusArray.length) {
			bookingStatusArray = bookingStatusArray && bookingStatusArray?.filter((obj) => { return obj.id === id && obj.userBookingStatus });
			if (bookingStatusArray.length == 0) return null;
			let name = "booked";
			name = Helper.getBookingStatusName(bookingStatusArray[0].userBookingStatus);
			return formatMsg(name);
		}
	}


	return (
		<CardWrapper
			style={styles.cardWrapper}
			styles={{ body: { padding: 0 } }}
			className="plv-card-wrapper"
		>
			<div>
				<Col className="firstCol" style={{ minHeight: '410px' }}>
					<div style={styles.mainCard} >
						<LinkWrapper href={redirectTo}>
							<div>
								<div className="tempDiv">
									<div className='imgDiv'>
										<img src={coverPhoto} alt="img" className='imgStylepkg' />
									</div>
								</div>
								<div className='infoDiv1'>
									<div className='displayFlexRow' style={{ marginTop: 8, marginBottom: 10 }}>
										{/* {loggedInData?.user?.id && !loggedInData?.schoolConfig?.hideWishList && (wishListed ? <img onClick={(e) => {
											e.preventDefault();
											e.stopPropagation();
											callUpdateWishlist(false)
										}} src={"/images/redHeart.png"} className='imgSrc redHeart' style={{ marginTop: '9px' }} />
											: <img onClick={(e) => {
												e.preventDefault();
												e.stopPropagation();
												callUpdateWishlist(true)
											}} src={"/images/redLineHeart.png"} className='imgSrc redHeart' style={{ marginTop: '9px' }} />)} */}
										<Tooltip title={name}>
											<div className='pack-name-overflow' style={{ marginTop: '10px' }} >{name}</div>
										</Tooltip>
									</div>
									{/* {
										(packageObj?.centers?.length >= 1) && 
										<div className='displayFlexRow flex-gap flex-dir-col'>
											<p style={{ display: 'flex' }}>
												<img src={"/images/location.png"} className='locationIconCardView' alt="calenderIcon" />
												<p className='global-card-header card-line-content'>
													{
														Helper.getDisplayNameOfCenter(packageObj.centers[0])
													}
													{
														(packageObj.centers.length > 1) &&
														<p className='purple-more-option'>
															{
																`+${packageObj.centers.length - 1} ${(packageObj.centers.length - 1 === 1) ? formatMsg('small.center') : formatMsg('small.centers')}`
															}
														</p>
													}
												</p>
											</p>
										</div>
									} */}
									<div className='ageRangeDiv displayFlexRow flex-gap flex-dir-col'>
										<p style={{ display: 'flex' }}>
											<img src={"/images/calender.png"} className='calenderIconCardView' alt="calenderIcon" />
											<p className='card-line-content'>
												{
													timeutil.getInstance(packageObj?.zerothBatch?.startDate).format(Helper.dateFormat(loggedInData))}{" - "}{timeutil.getInstance(packageObj?.zerothBatch?.endDate).format(Helper.dateFormat(loggedInData))
												}
												{/* {
													packageObj?.zerothBatch?.totalRunningDays &&
													<span style={{ fontWeight: '600', paddingLeft: '5px' }}>
														{`(${packageObj.zerothBatch.totalRunningDays} ${(packageObj?.zerothBatch?.totalRunningDays === 1) ? formatMsg('small.day') : formatMsg('days')})`}
													</span>
												} */}
												{
													((packageObj?.numberOfBatchesInPackage - 1) > 0) &&
													<p className='purple-more-option'>
														{
															`+${packageObj.numberOfBatchesInPackage - 1} ${(packageObj.numberOfBatchesInPackage - 1 === 1) ? formatMsg('option') : formatMsg('options')}`
														}
													</p>
												}
											</p>
										</p>
									</div>
									{
										(packageObj?.zerothBatch?.uniqueTimeSlotsObjList?.length > 0) &&
										<div
											className='ageRangeDiv displayFlexRow'
										>
											<img src={"/images/clock.png"} className='calenderIconCardView' alt="calenderIcon" />
											<div className='time-range card-line-content'>
												<span>
													{
														`${timeutil.getInstance(packageObj.zerothBatch.uniqueTimeSlotsObjList[0].startTime).format(Helper.getDefaultDateTimeFormat('time'))} - ${timeutil.getInstance(packageObj.zerothBatch.uniqueTimeSlotsObjList[0].endTime).format(Helper.getDefaultDateTimeFormat('time'))}`
													}
												</span>
												{(packageObj.zerothBatch.uniqueTimeSlotsObjList.length > 1) &&
													<span className='purple-more-option pt-1'>
														{`+${packageObj?.zerothBatch?.uniqueTimeSlotsObjList.length - 1} ${packageObj?.zerothBatch?.uniqueTimeSlotsObjList.length - 1 === 1 ? formatMsg('option') : formatMsg('options')}`}
													</span>
												}
											</div>
										</div>
									}
									{
										(ageRange && (ageRange.minYear || ageRange.minMonth || ageRange.maxYear || ageRange.maxMonth)) ?
											<div className='ageRangeDiv displayFlexRow'>
												<img
													src={"/images/ageRange.png"}
													className='calenderIconCardView'
													alt="calenderIcon"
												/>
												<p
													className="ageP card-line-content pt-1"
													style={{ fontSize: 'var(--font-size-14)', fontWeight: '500' }}
												>
													{Helper.renderAgeRange(ageRange)}												</p>
											</div>
											:
											null
									}
									{
										(packageObj?.daysOfWeek?.length > 0) &&
										<div className='ageRangeDiv displayFlexRow'>
											{Helper.getWeekDaysDisplayDiv(packageObj.daysOfWeek)}
										</div>
									}
									{/* {
										packageObj?.zerothBatch?.upcomingSlot &&
										<div className='ageRangeDiv displayFlexRow'>
											<span className="upcoming-slot-label" style={{ fontSize: 'var(--font-size-14)' }}>
												{formatMsg('upcomingSlot')}:
											</span>
											<span className='ml-5'>
												{
													timeutil.getInstance(packageObj.zerothBatch.upcomingSlot.date).format(Helper.dateFormat(loggedInData))
												}
											</span>
											<span>
												{
													`, ${timeutil.getInstance(packageObj.zerothBatch.upcomingSlot.startTime).format(Helper.getDefaultDateTimeFormat('time'))} - ${timeutil.getInstance(packageObj.zerothBatch.upcomingSlot.endTime).format(Helper.getDefaultDateTimeFormat('time'))}`
												}
											</span>
										</div>
									} */}
								</div>
							</div>
						</LinkWrapper>

						<div style={{ display: 'flex', justifyContent: 'center', alignItems: "center", marginTop: 10 }}>
							<LinkWrapper
								href={redirectTo}
								aTagStyle={{ width: '50%' }}
							>
								<div className='package-pricing'>
									{
										packageObj?.cheapestPrice && packageObj?.cheapestFrequency &&
										<div className='cheapest-price-container'>
											<span className='cheapest-price-div'>
												{Helper.getPricingPackName2({ frequencyValue: packageObj.cheapestFrequency, frequency: packageObj.cheapestFrequency, feeAmount: packageObj.cheapestPrice }, loggedInData)}
											</span>
											<span className='onwards-text'>
												{formatMsg('onwards')}
											</span>
										</div>
									}
								</div>
							</LinkWrapper>
							<LinkWrapper
								href={`/dashboard/book?id=${packageObj?.id}&centerId=${Helper.getUrlParam("centerId") || getItem("centerId")}`}
								aTagStyle={{ width: '50%' }}
							>
								<PrefixIconButton
									title={getBookingStatus() ? getBookingStatus() : formatMsg("bookNow")}
									width="100%"
									maxWidth="350px"
									height="36px"
									outerDivWidth="100%"
									prefixRight={"9px"}
									onClick={() => null}
									borderRadius={'8px'}
									type={"primary"}
								/>
							</LinkWrapper>
						</div>
					</div>
				</Col>
			</div >
		</CardWrapper>
	);
};


export default PackageView;


const styles: any = {
	cardWrapper: {
		position: "relative",
		width: '100%',
		maxWidth: '350px',
		minHeight: '410px',
		padding: 10,
		margin: 0,
		boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px'
	},
	mainCard: {
		minHeight: '410px',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between'
	}
}

